var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdenVentaImprimir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 178 178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ff8e31;}.cls-3{fill:#ed7425;}.cls-4{fill:#d41a1a;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill-opacity:0.39;}.cls-7{fill:#e55a5a;}.cls-8{fill:#fff;}.cls-9{fill:#cee2f2;opacity:0.02;}.cls-10{fill:#34495e;}.cls-11{fill:#5d6d7e;}.cls-12{fill:#677a8e;}.cls-13{fill:#283a4d;}.cls-14{fill:#b8d1e6;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.69,23.75l38.74,38.74H98.65a6.56,6.56,0,0,1-6-6Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "orden-venta-descargarPDF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 89,
    cy: 89,
    r: 89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.4,114.06,136.18,75.83a2,2,0,0,0-1.36-.56h-.18L121.86,62.5a1.83,1.83,0,0,0-.6-.41L121,62a1.09,1.09,0,0,0-.31-.08h0c-.06,0-.11,0-.16,0h0l-4.23-4.21-9.66-9.66H61.66V61.94H57.5a1.83,1.83,0,0,0-1.35.56,1.91,1.91,0,0,0-.57,1.34V75.27H43.19a1.91,1.91,0,0,0-1.92,1.92v38.17a2,2,0,0,0,.56,1.36l35.6,35.59.25.27h0l.35.35,24.1,24.1A89.08,89.08,0,0,0,174.4,114.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4-6",
    className: "cls-4",
    d: "M40.72,25.84A5.42,5.42,0,0,0,35.57,31V139.1a5.66,5.66,0,0,0,5.15,5.15h82.37a5.66,5.66,0,0,0,5.15-5.15V59.3L94.78,25.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8-3",
    className: "cls-6",
    d: "M94.48,26.64,128,60.1H99.63A5.65,5.65,0,0,1,94.48,55Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    className: "cls-7",
    d: "M94.78,25.84,128.24,59.3H99.93a5.66,5.66,0,0,1-5.15-5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    className: "cls-8",
    d: "M71.31,57.1a5.12,5.12,0,0,0-5,6c.43,4.6,3.4,8.34,5.71,12.14.26,1.41-.48,2.79-.53,4.2a98.7,98.7,0,0,1-7.36,24c-4.38,2-9.35,4-11.92,8.36a5.25,5.25,0,0,0,4,7.41c3.12.43,5.44-2.24,7.15-4.48,1.78-2.42,3-5.29,4.43-7.88a102.59,102.59,0,0,1,28.05-7.09c3.89,2.78,8,6.07,13,6.27a5.24,5.24,0,0,0,4.94-5.72c-.19-2.61-2.5-4.44-4.9-4.93-3.87-1.16-8-.52-12-.49a100.55,100.55,0,0,1-20.07-21c.41-4.85,1.23-10.2-1.29-14.61a4.85,4.85,0,0,0-4.3-2.19m.15,4.4c.85.16.91,1.43,1.15,2.11a24.45,24.45,0,0,1,.18,4.19c-1-1.89-2.33-3.88-2.1-6.13.27,0,.51-.14.77-.17m4.7,18.88a116,116,0,0,0,15,15.47,111.94,111.94,0,0,0-21.25,5.43,119.43,119.43,0,0,0,6-21.24l.29.34m28.15,18.87c1.75.17,3.77.07,5.17,1.27.13,1.09-1.2,1.25-1.91.86a14.92,14.92,0,0,1-4.2-2.06c.32,0,.63-.06.94-.07M60.58,110.7a14.78,14.78,0,0,1-3.31,4.1c-.42.68-1.57-.58-1-1.11,1.1-1.71,3-2.62,4.7-3.65-.11.22-.23.44-.35.66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 82.34,
    y: 94.16,
    width: 60.09,
    height: 60.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M142.43,141.38a1.29,1.29,0,0,1-.35.88,1.19,1.19,0,0,1-.85.36H83.54a1.17,1.17,0,0,1-.84-.36,1.26,1.26,0,0,1-.36-.88V124h60.09v17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M142.43,124H82.34v-7.46a1.24,1.24,0,0,1,.36-.88,1.17,1.17,0,0,1,.84-.36h57.69a1.19,1.19,0,0,1,.85.36,1.27,1.27,0,0,1,.35.88V124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M82.34,118.78v-2.27a1.24,1.24,0,0,1,.36-.88,1.17,1.17,0,0,1,.84-.36H103l8.41,8.7H87.36Zm27.58-3.51h-5.2l8.42,8.7h5.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M135.2,131.43a1.24,1.24,0,0,0-.36-.88,1.17,1.17,0,0,0-.85-.36H90.73a1.19,1.19,0,0,0-.85.36,1.27,1.27,0,0,0-.35.88v11.19H135.2V131.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M90.13,142.62V131.43a.6.6,0,0,1,.18-.44.56.56,0,0,1,.42-.18H134a.58.58,0,0,1,.43.18.65.65,0,0,1,.18.44v11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M130.39,136.44a.52.52,0,0,0-.14-.35.46.46,0,0,0-.34-.15H94.82a.45.45,0,0,0-.34.15.49.49,0,0,0-.14.35v2h36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M133.42,149.62a1.24,1.24,0,0,1-.36.88,1.17,1.17,0,0,1-.85.36H92.56a1.17,1.17,0,0,1-.85-.36,1.23,1.23,0,0,1-.35-.88V138.43h42.06v11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M133.42,119H91.36V107.83a1.23,1.23,0,0,1,.35-.88,1.15,1.15,0,0,1,.85-.37h39.66a1.18,1.18,0,0,1,.85.37,1.27,1.27,0,0,1,.35.88V119Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "95.18 119.02 129.55 119.02 129.55 103.84 123.47 97.55 95.18 97.55 95.18 119.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "129.55 103.84 123.47 97.55 123.47 103.84 129.55 103.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 95.18,
    y: 136.92,
    width: 34.37,
    height: 12.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.94,
    y: 138.64,
    width: 28.84,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.94,
    y: 140.24,
    width: 28.84,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.94,
    y: 141.83,
    width: 28.84,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.94,
    y: 143.43,
    width: 28.84,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.94,
    y: 145.02,
    width: 14.42,
    height: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M139.89,131.51a.24.24,0,0,1-.24.24H138a.24.24,0,0,1-.24-.24v-1.07a.25.25,0,0,1,.24-.25h1.68a.24.24,0,0,1,.24.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M139.89,135.05a.24.24,0,0,1-.24.25H138a.25.25,0,0,1-.24-.25V134a.25.25,0,0,1,.24-.25h1.68a.24.24,0,0,1,.24.25Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdenVentaImprimir);
export default __webpack_public_path__ + "static/media/orden-venta-imprimir.8c7611d1f08591daaeff4eea99311f1b.svg";
export { ForwardRef as ReactComponent };